import { render, staticRenderFns } from "./DecorationRenderer.vue?vue&type=template&id=240f1576&scoped=true"
import script from "./DecorationRenderer.vue?vue&type=script&lang=js"
export * from "./DecorationRenderer.vue?vue&type=script&lang=js"
import style0 from "./DecorationRenderer.vue?vue&type=style&index=0&id=240f1576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f1576",
  null
  
)

export default component.exports